module.exports = __webpack_public_path__ + "img/loginNew2.068bd4f8.png";